import { inject, Injectable } from '@angular/core';
import { ApiService } from './api-service';
import { GalleryDetail, GallerySummary } from '../models/cms-models';
import { ImagesService } from './images-service';

@Injectable({
  providedIn: 'root',
})
export class GalleriesService {
  private apiService = inject(ApiService);
  private imagesService = inject(ImagesService);

  async getSiteGalleries(siteId: string): Promise<GallerySummary[]> {
    return this.apiService.get<GallerySummary[]>(`api/gallery/site/${siteId}`);
  }

  async getGallery(galleryId: string): Promise<GalleryDetail> {
    const gallery = await this.apiService.get<GalleryDetail>(`api/gallery/${galleryId}`);
    return {
      ...gallery,
      images: await Promise.all(gallery.images.map((image) => this.imagesService.hydrateImage(image))),
    };
  }

  async createGallery(input: {
    siteId: string;
    name: string;
    imageIds: string[];
  }): Promise<GalleryDetail> {
    return this.apiService.post<GalleryDetail, typeof input>('api/gallery', input);
  }

  async updateGallery(galleryId: string, input: {
    siteId: string;
    name: string;
    imageIds: string[];
  }): Promise<GalleryDetail> {
    return this.apiService.put<GalleryDetail, typeof input>(`api/gallery/${galleryId}`, input);
  }

  async deleteGallery(galleryId: string): Promise<void> {
    await this.apiService.delete(`api/gallery/${galleryId}`);
  }
}
